import UploadScoreCardPage from './UploadScoreCardPage';

export default UploadScoreCardPage;


// WEBPACK FOOTER //
// ./src/features/score-card/pages/upload-score-card-page/index.js